export default "__VITE_ASSET__DYFNPIAE__"